<ol class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
  <li
    class="breadcrumb__item breadcrumb__item--link"
    itemprop="itemListElement"
    itemscope
    itemtype="https://schema.org/ListItem"
  >
    <vc-ref microData="item" resource="/">
      <span itemprop="name" i18n="@@JOURNAL_MAIN.BREADCRUMB.HOME">Home</span></vc-ref
    >
    <meta itemprop="position" content="1" />
  </li>
  <li
    class="breadcrumb__item breadcrumb__item--link"
    itemprop="itemListElement"
    itemscope
    itemtype="https://schema.org/ListItem"
  >
    <vc-ref microData="item" resource="/journal/">
      <vc-sprite-icons class="breadcrumb__item__icon" name="arrow-head-right"></vc-sprite-icons>
      <span itemprop="name">Journal</span></vc-ref
    >
    <meta itemprop="position" content="2" />
  </li>
  <li
    *ngIf="currentCategory?.id !== defaultCategory.id"
    class="breadcrumb__item"
    itemprop="itemListElement"
    itemscope
    itemtype="https://schema.org/ListItem"
  >
    <span>
      <vc-sprite-icons class="breadcrumb__item__icon" name="arrow-head-right"></vc-sprite-icons>
      <span itemprop="name">{{ currentCategory?.title }}</span>
    </span>
    <meta itemprop="item" content="{{ completeUrl }}" />
    <meta itemprop="position" content="3" />
  </li>
</ol>
